import setPmkinoWebAppState from "../functions/webapp/setPmkinoWebAppState"
import { checkAndroidApp, checkPmkinoWebApp, checkWebApp } from "./checkWebApp"
import { getUserAgent } from "./getUserAgent"
import { setEntryLocale } from "./setEntryLocale"
import { setWeischerCookie } from "./setWeischerCookie"

export const setEntry = () => {
    setEntryLocale()
    setWeischerCookie()

    const {
        iOS,
        firefox,
        android,
        isMobile
    } = getUserAgent()

    const isAndroidApp = checkAndroidApp()
    const isWebApp = checkWebApp(isAndroidApp)
    const isPmkinoWebApp = checkPmkinoWebApp(isAndroidApp)

    if ((android && isMobile && firefox) || iOS || isWebApp) {
        document.querySelector("html").classList.add("is-ios");
    }

    if(isPmkinoWebApp) {
        setPmkinoWebAppState()
    }

    return [isWebApp, isMobile]
}